<h2 class="p-6 pb-4">{{ medication() ? "Редагування лікарського засобу" : "Додавання лікарського засобу" }}</h2>
<div class="overflow-y-auto px-6 py-0">
  @if (!loading()) {
    <div
      class="flex flex-col rounded-lg border-2 border-transparent p-3 shadow-inner"
      [formGroup]="medicationForm"
      [ngClass]="{ 'border-warning-500': mappingInvalid() }"
    >
      @if (mappingInvalid()) {
        <div class="paragraph-2 mb-4 rounded-xl bg-warning-50 p-4 text-warning-600">
          {{ "prescription.message.invalidMappingWarning" | translate }}
        </div>
      }
      <div
        class="flex flex-col"
        [formGroupName]="'metadata'"
      >
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
        >
          <mat-tab label="Обрати через МНН">
            <mat-form-field class="mt-2 w-full">
              <mat-label>МНН</mat-label>
              <input
                matInput
                type="text"
                formControlName="inn"
                [matAutocomplete]="medicalTreatmentAutocomplete"
              />
              <mat-autocomplete
                #medicalTreatmentAutocomplete="matAutocomplete"
                (optionSelected)="selectInn($event.option.value)"
              >
                @for (option of innsOptions(); track $index) {
                  <mat-option [value]="option.toUpperCase()">
                    {{ option.toUpperCase() }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </mat-tab>
          <mat-tab label="Обрати через ТН">
            <mat-form-field class="mt-2 w-full">
              <mat-label>МНН</mat-label>
              <input
                matInput
                type="text"
                formControlName="inn"
                [matAutocomplete]="trademarksMedicalTreatmentAutocomplete"
              />
              <mat-autocomplete
                #trademarksMedicalTreatmentAutocomplete="matAutocomplete"
                (optionSelected)="selectInnByTrademark($event.option.value)"
              >
                @for (option of trademarksOptions(); track option.code) {
                  <mat-option [value]="option">
                    {{ option.nameFullUa }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </mat-tab>
        </mat-tab-group>

        <div class="flex w-full gap-4">
          <mat-form-field class="w-full">
            <mat-label>Лікарська форма</mat-label>
            <mat-select
              formControlName="form"
              [multiple]="true"
              (selectionChange)="selectMedicationForm($event.value)"
            >
              @for (option of formsOptions(); track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="flex h-14 pt-2">
            <mat-icon
              aria-hidden="false"
              aria-label="Info icon"
              fontIcon="info"
              [matTooltip]="'Торгові назви'"
              matTooltipPosition="above"
              class="text-gray-600 hover:text-blue-500 hover:cursor-pointer"
              (click)="toggleTrademarksInfoSection()"
            ></mat-icon>
          </div>
        </div>
        @if (mappingInvalid()) {
          <p class="paragraph-2 -mt-2 mb-4 text-warning-600">
            {{ "prescription.message.invalidMappingShouldBeUpdated" | translate }}
          </p>
        }

        @if (showTrademarksInfo()) {
          @if (!!medicationForm.get("metadata.morionItems").value && medicationForm.get("metadata.morionItems").value.length > 0) {
            <div class="mb-4 flex flex-col gap-2 rounded-2xl bg-white p-4">
              @for (trademark of medicationForm.get("metadata.morionItems").value; track trademark.code) {
                <div class="flex items-center gap-1">
                  <span
                    class="max-w-[425px] overflow-hidden text-ellipsis whitespace-nowrap"
                    [ngClass]="{ 'text-green-success': trademark.isRecommended }"
                    [matTooltip]="trademark.nameFullUa"
                  >
                    {{ trademark.nameFullUa }}
                  </span>
                  @if (!!trademark.quantityInPackage) {
                    <span class="text-xs text-gray-1">{{ trademark.quantityInPackage }} од/уп</span>
                  }
                </div>
              }
            </div>
          } @else {
            <div class="mb-4 flex flex-col gap-2 rounded-2xl bg-white p-4">Торгових марок не знайдено</div>
          }
        }

        <div class="flex gap-4">
          <mat-form-field class="w-1/3">
            <mat-label>Разова доза</mat-label>
            <input
              matInput
              formControlName="singleDose"
              type="number"
              onkeypress="return event.charCode >= 48;"
              [min]="1"
            />
          </mat-form-field>

          <mat-form-field class="w-1/3">
            <mat-label>Кількість прийомів на добу</mat-label>
            <mat-select formControlName="frequency">
              @for (frequency of drugsFrequencyOptions; track frequency.value) {
                <mat-option [value]="frequency.value">
                  {{ frequency.frequency }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-1/3">
            <mat-label>Тривалість лікування (днів)</mat-label>
            <input
              matInput
              formControlName="duration"
              type="number"
              onkeypress="return event.charCode >= 48;"
              [min]="1"
            />
          </mat-form-field>
        </div>

        <div class="flex w-full gap-4">
          <mat-form-field class="w-1/2">
            <mat-label>Добова доза</mat-label>
            <input
              matInput
              readonly
              type="number"
              formControlName="dailyAmount"
            />
          </mat-form-field>
          <mat-form-field class="w-1/2">
            <mat-label>Курсова кількість (шт)</mat-label>
            <input
              matInput
              formControlName="treatmentDose"
              type="number"
              onkeypress="return event.charCode >= 48;"
              [min]="1"
            />
            @if (!!metadataFc.treatmentDose.value && metadataFc.treatmentDoseConfirmation.value !== true) {
              <mat-hint class="text-red-error">Перевірте та підтвердіть курсову кількість</mat-hint>
            }
          </mat-form-field>
          <mat-checkbox
            formControlName="treatmentDoseConfirmation"
            matTooltip="Підтверджую курсову кількість лікування"
            matTooltipPosition="above"
            color="primary"
          >
          </mat-checkbox>
        </div>
        <div class="mb-4">
          @if (loadingPharmaciesCount()) {
            <div class="paragraph-2 flex items-center gap-2 rounded-xl bg-neutral-100 p-4 text-neutral-500">
              Шукаємо в аптеках <shared-spin-loading [size]="16"></shared-spin-loading>
            </div>
          } @else {
            <div
              class="paragraph-2 flex rounded-xl p-4"
              [ngClass]="{
                'bg-neutral-100 text-neutral-500': pharmaciesCount() === null,
                'bg-error-50 text-error-600': pharmaciesCount() < 20,
                'bg-warning-50 text-warning-600': pharmaciesCount() >= 20 && pharmaciesCount() < 100,
                'bg-success-50 text-success-600': pharmaciesCount() >= 100,
              }"
            >
              @if (pharmaciesCount() !== null) {
                Знайдено {{ pharmaciesCount() }} аптек з цим препаратом в наявності
              } @else {
                Виберіть МНН, форму та кількість, щоб почати шукати аптеки
              }
            </div>
          }
        </div>
      </div>
      <div class="flex w-full gap-4">
        <mat-form-field class="w-1/2">
          <mat-label>Дата з</mat-label>
          <input
            matInput
            formControlName="startDate"
            [matDatepicker]="dateFromPicker"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="dateFromPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateFromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="w-1/2">
          <mat-label>Дата до</mat-label>
          <input
            matInput
            formControlName="endDate"
            [matDatepicker]="dateTillPicker"
            [min]="fc.startDate.value"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="dateTillPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateTillPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="flex w-full gap-4">
        <mat-form-field class="full grow">
          <mat-label>Франшиза</mat-label>
          <input
            matInput
            formControlName="franchise"
            type="number"
            [max]="100"
            [min]="0"
          />
          @if (fc.franchise.hasError("required")) {
            <mat-error class="text-sm text-red-error">Поле обов'язкове для заповнення (ціле число від 0 до 100)</mat-error>
          }
          @if (fc.franchise.hasError("max")) {
            <mat-error class="text-sm text-red-error">Франшиза не може бути більше 100%</mat-error>
          }
          @if (fc.franchise.hasError("min")) {
            <mat-error class="text-sm text-red-error">Франшиза не може бути менше 0%</mat-error>
          }
          @if (fc.franchiseManualChangeConfirmation.hasError("required")) {
            <mat-hint class="text-sm text-red-error">Перевірте та підтвердіть зміну відсотку франшизи</mat-hint>
          }
        </mat-form-field>
        @if (franchiseInitialValue() !== fc.franchise.value) {
          <mat-checkbox
            formControlName="franchiseManualChangeConfirmation"
            matTooltip="Підтверджую зміну відсотку франшизи"
            matTooltipPosition="above"
            color="primary"
          >
          </mat-checkbox>
        }
      </div>
      <mat-form-field class="w-full">
        <mat-label>Статус</mat-label>
        <mat-select formControlName="guaranteeStatus">
          @for (status of guaranteeStatusOptions; track status) {
            <mat-option
              [value]="status"
              [ngClass]="{ '!hidden': status === guaranteeStatus.Auto || status === guaranteeStatus.Unknown }"
            >
              {{ "statuses.guarantationStatuses." + status | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (statusChanged()) {
        @if (fc.guaranteeStatus.value === guaranteeStatus.Guaranteed) {
          <mat-form-field class="w-full">
            <mat-label>{{ "prescription.label.editReason" | translate }}</mat-label>
            <input
              matInput
              formControlName="statusReason"
            />
          </mat-form-field>
        } @else {
          <mat-form-field class="w-full">
            <mat-label>{{ "prescription.label.declineReason" | translate }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="statusReason"
              [matAutocomplete]="declineReasonAutocomplete"
            />
            <mat-autocomplete #declineReasonAutocomplete="matAutocomplete">
              @for (reason of filteredDeclineReasons(); track reason) {
                <mat-option [value]="reason">
                  {{ reason }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }
      }
      @if (dataChanged()) {
        <mat-form-field class="w-full">
          <mat-label>Причина редагування</mat-label>
          <input
            matInput
            type="text"
            formControlName="editReason"
            [matAutocomplete]="editReasonAutocomplete"
          />
          <mat-autocomplete #editReasonAutocomplete="matAutocomplete">
            @for (reason of filteredEditReasons(); track reason) {
              <mat-option [value]="reason">
                {{ reason }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      @if (
        !!this.guaranteeApplicationId() &&
        (this.fc.guaranteeStatus.value === this.guaranteeStatus.Auto || this.fc.guaranteeStatus.value === this.guaranteeStatus.Guaranteed) &&
        (!this.medication() || !!this.medication()?.creationDate)
      ) {
        <div class="mb-4 flex items-center gap-4">
          <mat-checkbox [formControl]="fc.completedInAppointment">{{ "prescription.label.completed" | translate }}</mat-checkbox>
        </div>

        @if (fc.completedInAppointment.value === true) {
          <mat-form-field class="w-full">
            <mat-label>{{ "prescription.label.completionReason" | translate }}</mat-label>
            <input
              matInput
              type="text"
              [formControl]="fc.completionReason"
            />
            @if (fc.completionReason?.invalid) {
              <mat-error class="text-sm text-red-error-dark">{{ "validation.error.required" | translate }}</mat-error>
            }
          </mat-form-field>
        }
      }
    </div>
  } @else {
    <div class="flex items-center justify-center">
      <shared-loader></shared-loader>
    </div>
  }
</div>

<div class="flex justify-end gap-4 p-6">
  <button
    class="btn btn-secondary"
    [type]="'button'"
    [disabled]="loading()"
    (click)="closeDialog()"
  >
    Скасувати
  </button>
  <button
    class="btn btn-primary"
    [type]="'submit'"
    [disabled]="loading() || fc.completedInAppointment.value === true"
    (click)="submitDraft()"
  >
    Зберегти чернетку
  </button>
  @if (!!guaranteeApplicationId() && (!medication() || !!medication()?.creationDate)) {
    <button
      class="btn btn-primary"
      [type]="'submit'"
      [disabled]="loading()"
      (click)="submitPrescription()"
    >
      Зберегти
    </button>
  }
</div>
